"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PartnerContactEmailType = void 0;
var PartnerContactEmailType;
(function (PartnerContactEmailType) {
    PartnerContactEmailType["E_INVOICE"] = "e-invoice";
    PartnerContactEmailType["ORDERS_FROM"] = "orders";
    PartnerContactEmailType["ACKNOWLEDGE_TO"] = "acknowledgements";
    PartnerContactEmailType["CONFIRMATION_TO"] = "confirmations";
})(PartnerContactEmailType = exports.PartnerContactEmailType || (exports.PartnerContactEmailType = {}));
//# sourceMappingURL=partner-contact-email-type.enum.js.map